import React from "react";
import Com from "components/styledComp/CommStyledComp";
import SpdstPrprtiesMain from "./SpdstPrprtiesMain";
import CompetitorsMain from "./CompetitorsMain";
import SpdstDesc from "./SpdstDesc";

const SpdstMain = () => {
  return (
    <Com.DivDetailSection>
      <SpdstDesc/>
      <SpdstPrprtiesMain/>
      <CompetitorsMain/>
    </Com.DivDetailSection>
  );
};

export default SpdstMain;
